// extracted by mini-css-extract-plugin
export var phone = "_1w-0";